import React, { useContext, useEffect, useState } from 'react'
import { UserOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Breadcrumb, Layout, Menu, Spin, theme } from 'antd'
import { Outlet, useNavigate, useLocation, Navigate } from 'react-router-dom'
import { AppContext } from '../../hooks/AppContext'
import Constant from '../../controller/Constant'

const { Header, Content, Sider } = Layout

const SideBarMenu = [
  //{
  //  label: 'Loraモデル学習',
  //  key: Constant.keyScreen.trainLora,
  //  icon: UserOutlined,
  //  route: 'train-lora'
  //},
  {
    label: '画像生成',
    key: Constant.keyScreen.img2img,
    icon: UserOutlined,
    route: 'img2img'
  },
  //{
  //  label: '学習履歴一覧',
  //  key: Constant.keyScreen.loraHistory,
  //  icon: UserOutlined,
  //  route: 'lora-history'
  //},
  {
    label: '画像生成履歴一覧',
    key: Constant.keyScreen.renderHistory,
    icon: UserOutlined,
    route: 'render-history'
  }
]

const BaseLayout = (props: any) => {
  const {
    token: { colorBgContainer, borderRadiusLG }
  } = theme.useToken()
  const navigate = useNavigate()

  const location = useLocation()
  const { menuSelected, setMenuSelected, isMobile } = useContext(AppContext)

  const items2: MenuProps['items'] = SideBarMenu.map((e) => {
    return {
      key: `${e.key}`,
      label: `${e.label}`,
      onClick: () => {
        if (e.route == 'login') {
          localStorage.clear()
        }
        navigate(e.route)
      }
    }
  })

  return (
    <Layout>
      <Layout>
        <Sider
          width={230}
          style={{ background: colorBgContainer }}
          // collapsible
          collapsed={isMobile}
          collapsedWidth={isMobile ? 40 : undefined}
        >
          <Menu
            mode='inline'
            defaultSelectedKeys={['1']}
            defaultOpenKeys={['sub1']}
            style={{ height: '100%', borderRight: 0 }}
            items={items2}
            selectedKeys={[`${menuSelected}`]}
            onClick={(item) => {
              if (item.key === '5') {
                localStorage.clear()
              }
              setMenuSelected(Number(item.key))
            }}
          />
        </Sider>
        <Layout style={{ padding: ' 0px 24px 24px', minHeight: window.innerHeight }}>
          <Breadcrumb>
            {/* <Breadcrumb.Item>Home</Breadcrumb.Item>
                        <Breadcrumb.Item>List</Breadcrumb.Item>
                        <Breadcrumb.Item>App</Breadcrumb.Item> */}
            <h3></h3>
          </Breadcrumb>
          <Content
            style={{
              paddingLeft: 15,
              paddingRight: 10,
              margin: 0,
              minHeight: 280,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              height: '100%'
            }}
          >
            <Outlet />
            {/* {localStorage.getItem('token') ? <Outlet /> : <Navigate to='/login' replace />} */}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  )
}

export default BaseLayout
